import * as React from "react";
import { UitkSelect } from "uitk-react-select";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { UitkLayoutGridItem, UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { observer } from "mobx-react";

export interface CruiseCommon3PPSelectProps {
  colSpan: UitkLayoutConditionalGridSpan;
  icon: string;
  placeholder: string;
  id: string;
  param: string;
  currentValue: string;
  invalidMessage: string;
  items: any[];
  onChange: any;
}

export const CruiseCommon3PPSelect = observer((props: CruiseCommon3PPSelectProps) => {
  const { colSpan, icon, placeholder, id, currentValue, items, invalidMessage, param, onChange } = props;

  const commonKeyHelper = new ItemKeyHelper(`common-3pp-select-${id}`);

  const changeValue = (selectEvent: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(selectEvent.target.value);
  };

  return (
    <UitkLayoutGridItem colSpan={colSpan}>
      <div>
        {param && <input type="hidden" name={param} value={currentValue} />}
        <UitkSelect
          icon={icon}
          id={id}
          label={placeholder}
          placeholder={placeholder}
          invalid={invalidMessage}
          value={currentValue || undefined}
          onChange={changeValue}
        >
          {items.map(({ value, text }) => (
            <option value={value} key={commonKeyHelper.next()}>
              {text}
            </option>
          ))}
        </UitkSelect>
      </div>
    </UitkLayoutGridItem>
  );
});
